import { render, staticRenderFns } from "./remarks.vue?vue&type=template&id=3bc15f0a&scoped=true"
import script from "./remarks.vue?vue&type=script&lang=js"
export * from "./remarks.vue?vue&type=script&lang=js"
import style0 from "./remarks.vue?vue&type=style&index=0&id=3bc15f0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc15f0a",
  null
  
)

export default component.exports